import { render, staticRenderFns } from "./store-orders.vue?vue&type=template&id=6907f38f"
import script from "./store-orders.vue?vue&type=script&lang=js"
export * from "./store-orders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports